export default function animatedNumber(){
    Alpine.data('animatedNumber', () => ({
        startValue: 0,
        targetValue: 0,
        triangleStyle: '',
        triangleColor: '',
        displayValue: 0,
        passValues(startValue, targetValue, triangleStyle) {
            this.startValue = parseFloat(startValue);
            this.targetValue = parseFloat(targetValue);
            triangleStyle.includes('up') ? this.triangleStyle = 'up' : this.triangleStyle = 'down';
            triangleStyle.includes('green') ? this.triangleColor = 'green' : this.triangleColor = 'red';
            this.displayValue = this.startValue;
        },
        animateNumbers() {
            const startTime = performance.now();
            const startValue = this.displayValue;
            const endValue = this.targetValue;
            const duration = 2000;


            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                let progress = elapsedTime / duration;

                progress = 1 - Math.pow(1 - progress, 5);

                if (this.triangleStyle.includes('up')) {
                    this.displayValue = startValue + (endValue - startValue) * progress;
                } else if (this.triangleStyle.includes('down')) {
                    this.displayValue = startValue - (startValue - endValue) * progress;
                }

                this.updateDisplayValue();

                if (elapsedTime < duration) {
                    requestAnimationFrame(animate);
                } else {
                    this.displayValue = endValue;
                    this.updateDisplayValue();
                }
            };
            requestAnimationFrame(animate);
        },
        updateDisplayValue() {
            this.displayValue = Math.round(this.displayValue);
        },
        resetValues(){
            this.displayValue = this.startValue;
            this.targetValue = this.startValue;
        }
    }))

}